import { AnswerTypes } from '../enums/AnswerTypes';
import { IAnswer } from '../interfaces/Answer.interface';

// Initialize Answer state
export const INITIAL_ANSWER_STATE: IAnswer = {
  type: AnswerTypes.TEXT,
  order: 1,
  dataSources: [
    {
      options: [],
    },
  ],
};
